/**
 * Hero Block JavaScript
 */
(function() {
    'use strict';

    // YouTube API Player instances
    let bgPlayer = null;
    let modalPlayer = null;
    let isYouTubeAPIReady = false;

    // Initialize YouTube API
    function initYouTubeAPI() {
        if (window.YT && window.YT.Player) {
            onYouTubeIframeAPIReady();
            return;
        }

        if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    }

    function onYouTubeIframeAPIReady() {
        isYouTubeAPIReady = true;
        initYouTubeBackgrounds();
    }

    // Initialize YouTube background videos
    function initYouTubeBackgrounds() {
        const youtubeBackgrounds = document.querySelectorAll('.hero-youtube-background');
        
        youtubeBackgrounds.forEach((bg, index) => {
            const videoId = bg.dataset.videoId;
            const playerId = `youtube-player-${videoId}`;
            const playerContainer = bg.querySelector('.youtube-player');
            
            if (!videoId || !playerContainer) return;

            // Create YouTube player
            bgPlayer = new YT.Player(playerId, {
                videoId: videoId,
                playerVars: {
                    autoplay: 1,
                    mute: 1,
                    loop: 1,
                    playlist: videoId,
                    controls: 0,
                    showinfo: 0,
                    rel: 0,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    enablejsapi: 1,
                    origin: window.location.origin
                },
                events: {
                    onReady: function(event) {
                        console.log('YouTube background player ready');
                        event.target.mute();
                        event.target.playVideo();
                        
                        // Hide placeholder after video starts
                        setTimeout(() => {
                            const placeholder = bg.querySelector('.hero-youtube-placeholder');
                            if (placeholder) {
                                placeholder.style.opacity = '0';
                                setTimeout(() => {
                                    placeholder.style.display = 'none';
                                }, 500);
                            }
                        }, 1000);
                    },
                    onStateChange: function(event) {
                        // Loop the video manually
                        if (event.data === YT.PlayerState.ENDED) {
                            event.target.playVideo();
                        }
                    }
                }
            });
        });
    }

    // Initialize video modal functionality
    function initVideoModal() {
        const videoButtons = document.querySelectorAll('.video-modal-trigger');
        const modal = document.getElementById('video-modal');
        const modalClose = document.querySelector('.video-modal-close');
        const modalOverlay = document.querySelector('.video-modal-overlay');
        const modalPlayerContainer = document.getElementById('modal-youtube-player');

        if (!modal) return;

        // Function to extract YouTube video ID from URL
        function getYouTubeID(url) {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);
            return (match && match[2].length === 11) ? match[2] : null;
        }

        // Function to open modal
        function openModal(videoUrl) {
            const videoId = getYouTubeID(videoUrl);
            if (!videoId) return;

            modal.classList.add('active');
            document.body.style.overflow = 'hidden';

            // Create YouTube player in modal
            if (isYouTubeAPIReady) {
                modalPlayer = new YT.Player('modal-youtube-player', {
                    videoId: videoId,
                    playerVars: {
                        autoplay: 1,
                        controls: 1,
                        showinfo: 0,
                        rel: 0,
                        modestbranding: 1,
                        enablejsapi: 1,
                        origin: window.location.origin
                    },
                    events: {
                        onReady: function(event) {
                            event.target.playVideo();
                        }
                    }
                });
            } else {
                // Fallback to iframe
                modalPlayerContainer.innerHTML = `
                    <iframe 
                        src="https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&showinfo=0&rel=0&modestbranding=1" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen>
                    </iframe>
                `;
            }
        }

        // Function to close modal
        function closeModal() {
            modal.classList.remove('active');
            document.body.style.overflow = '';

            // Destroy player and clear container
            if (modalPlayer && typeof modalPlayer.destroy === 'function') {
                modalPlayer.destroy();
                modalPlayer = null;
            }
            modalPlayerContainer.innerHTML = '';
        }

        // Event listeners
        videoButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const videoUrl = this.dataset.videoUrl;
                if (videoUrl) {
                    openModal(videoUrl);
                }
            });
        });

        if (modalClose) {
            modalClose.addEventListener('click', closeModal);
        }

        if (modalOverlay) {
            modalOverlay.addEventListener('click', closeModal);
        }

        // ESC key to close modal
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModal();
            }
        });
    }

    // Initialize scroll indicators
    function initScrollIndicators() {
        const scrollIndicators = document.querySelectorAll('.hero-scroll-indicator');
        
        scrollIndicators.forEach(indicator => {
            indicator.addEventListener('click', function(e) {
                e.preventDefault();
                
                const heroBlock = this.closest('.hero-block');
                let nextElement = heroBlock.nextElementSibling;
                
                // Find the next meaningful section
                while (nextElement && (
                    nextElement.classList.contains('hero-block') ||
                    nextElement.offsetHeight < 50 ||
                    getComputedStyle(nextElement).display === 'none'
                )) {
                    nextElement = nextElement.nextElementSibling;
                }
                
                if (nextElement) {
                    nextElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                } else {
                    window.scrollBy({
                        top: window.innerHeight,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    // Initialize everything
    function init() {
        initYouTubeAPI();
        initVideoModal();
        initScrollIndicators();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();